import evaluationResultLabelsService from "presentation/services/evaluation-result-labels";
import evaluationResultLabelTermsFunctions from 'presentation/pages/evaluation-result-labels/functions/evaluation-result-label-terms';
import { goTo } from "presentation/utils/functions/generic";



export const handleSubmit = async (component) => {
    const { form, evaluationResultLabelTerms } = component.state;
    component.setState({ loading: true, actionLoading: true, error: '' });
    const {
        name,
    } = form;
    let errors = [];

    if (!name) {
        errors.push("Por favor, preencha um nome para esse rótulo...");
    }

    let handledItems = evaluationResultLabelTerms;


    let handledItemsSize = handledItems.length;
    if (handledItemsSize > 0) {
        let count = handledItems.filter((item) => item.name === '').length;
        if (count > 0) {
            errors.push("Uma ou mais termos do rótulo não tem nome...");
        }
    } else {
        errors.push("Você precisa adicionar termos para esse rótulo de resultado...");
    }


    if (errors.length > 0) {
        component.setState({ loading: false, error: true, message: errors.join(" <br />") });
    } else {
        let postData = component.state.form;
        try {
            const response = await evaluationResultLabelsService.save(postData);
            if (response.error == true) {
                component.setState({
                    loading: false,
                    actionLoading: false,
                    error: true,
                    message: response.message
                });
            } else {
                let promises = evaluationResultLabelTermsFunctions.prepareItemsRequests(response, handledItems);
                if (!promises) {
                    component.setState({
                        loading: false,
                        actionLoading: false,
                        error: true,
                        message: 'Erro ao tentar criar os termos de rótulo de resultado de avaliação...'
                    });
                } else {
                    await Promise.all(promises);
                    goTo("/rotulos-resultado-avaliacao", component);
                }
            }
        } catch (err) {
            component.setState({
                loading: false,
                actionLoading: false,
                error: true,
                message: err.message
            });
        }
    }
};

const evaluationResultLabelFunctions = {
    handleSubmit
}

export default evaluationResultLabelFunctions;